<template>
  <div class="OrgProfile">
    <ShortNavbar class="Navbar" />

    <div class="Content">
      <router-view />
    </div>

    <GeneralFooter class="Footer" />
  </div>
</template>

<script>
import ShortNavbar from "@/components/ShortNavbar";
import GeneralFooter from "@/components/Footer";

export default {
  components: { ShortNavbar, GeneralFooter },
};
</script>

<style scoped>
.OrgProfile {
  position: relative;
  display: flex;

  width: 100%;
  height: auto;
  min-height: 100svh;

  flex-direction: column;
  justify-content: flex-start;

  background-color: white;
}

.Footer {
  margin-top: auto;
}
.Navbar {
  position: absolute;
  padding: 15px 0%;
  top: 0;
}

.Content {
  position: relative;
  display: flex;

  margin-top: 80px;
  margin-bottom: 165px;
  padding-top: 40px;

  width: 100%;
  height: fit-content;
}
</style>
